export const modalText = 'Remove this notification?';
export const dismissText = 'notification dismissed';



// WEBPACK FOOTER //
// src/dashboard/messages/message-constants.js